import { PaymentApiClient } from '@fourthwall/services/dist/PaymentApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useMarkBlockedTransactionsAsSeenMutation = createMutationHook(
  PaymentApiClient.markBlockedTransactionsAsSeen,
  {
    mutationKey: ['markBlockedTransactionsAsSeen'],
  },
)
